import React, { useEffect, useState } from "react";

//router
import Link from "next/link";

// header
import HeaderDefault from "../components/partials/HeaderDefault";

// footer
import FooterDefault from "../components/partials/FooterDefault";

//breadcrumb
import BreadCrumbWidget from "@/components/BreadcrumbWidget";

// Theme
// import { useTheme } from "@/hooks/useTheme";


// This function safely renders children, preventing React Error #31
// during server-side rendering and static generation
function renderChildrenSafely(children: React.ReactNode): React.ReactNode {
  // Handle null/undefined case
  if (children == null) return null;

  // Handle single child case that is a valid React element
  if (React.isValidElement(children)) {
    return React.cloneElement(children);
  }

  // Handle array of children with proper validation
  if (Array.isArray(children) || typeof children === 'object') {
    return React.Children.map(children, child => {
      // Skip null/undefined children
      if (child == null) return null;

      // Properly handle valid React elements
      if (React.isValidElement(child)) {
        return React.cloneElement(child);
      }

      // Handle primitive values (string, number, etc.)
      if (typeof child !== 'object') {
        return child;
      }

      // Log warning for potentially problematic children during development
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Non-element object child in layout:', child);
      }

      // Convert to string as fallback for objects
      return String(child);
    });
  }

  // For primitive values (string, number, boolean)
  return children;
}

const Frontend = (({ children }: any) => {
  const [animationClass, setAnimationClass] = useState("animate__fadeIn");
  const [isClient, setIsClient] = useState(false);

  // Use the theme hook to handle theme logic (disabled for MVP static dark mode)
  // useTheme();

  // Safe scrollToTop function with client-side check
  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Safe handleScroll function with client-side check
  const handleScroll = () => {
    if (typeof document !== 'undefined') {
      if (document.documentElement.scrollTop > 250) {
        setAnimationClass("animate__fadeIn");
      } else {
        setAnimationClass("animate__fadeOut");
      }
    }
  };

  // First useEffect to detect client-side rendering
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Second useEffect for browser-specific operations, only runs on client
  useEffect(() => {
    if (!isClient) return;

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    // Enforce static dark mode for all users (see theme improvements spec)
    document.documentElement.setAttribute('data-bs-theme', 'gschool');
    document.documentElement.setAttribute('data-effective-theme', 'dark');
    document.documentElement.setAttribute('data-color-scheme', 'dark');

    // Theme toggling is currently disabled; see theme improvements spec for details
    // To re-enable, restore toggler logic and user/system preference handling

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isClient]);

  return (
    <>
      <main className="main-content">
        <BreadCrumbWidget />
        <HeaderDefault />

        <div className="body-content-wrapper">
          {renderChildrenSafely(children)}
        </div>
      </main>
      <FooterDefault />
      <div
        id="back-to-top"
        style={{ display: "none" }}
        className={`animate__animated ${animationClass}`}
        onClick={scrollToTop}
      >
        <Link
          className="p-0 btn bg-primary btn-sm position-fixed top border-0 rounded-circle"
          id="top"
          href="#top"
        >
          <i className="fa-solid fa-chevron-up"></i>
        </Link>
      </div>
      {/* <SettingOffCanvas /> // Hide the Live Customizer widget */}
    </>
  )
})

export default Frontend
